/* eslint-disable camelcase */ /* eslint-disable react/prop-types */ import React, {  useState,
  useEffect,
} from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import moment from 'moment-timezone';

import {
  TableRow,
  TableHead,
  TableContainer,
  TableCell,
  TableBody,
  Table,
  Paper,
  TablePagination,
} from '@material-ui/core';

import GetApp from '@material-ui/icons/GetApp';
import { formatCurrency } from '../../../../service/utils';

function createData(
  id,
  invoice_number,
  order_number,
  client_name,
  amount,
  date_payment,
  date_conciliation,
) {
  return {
    id,
    invoice_number,
    order_number,
    client_name,
    amount,
    date_payment,
    date_conciliation,
  };
}

const useStyles = makeStyles({
  root: {
    width: '100%',
  },
  container: {
    maxHeight: 440,
  },
  table: {
    minWidth: 1100,
  },
});

const StyledTableCell = withStyles(() => ({
  head: {
    backgroundColor: '#303474',
    color: 'white',
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

export default function ReportTable({
  docs,
  page,
  setPage,
  itens,
  setItens,
  total,
  getXls,
}) {
  const classes = useStyles();
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (docs) {
      const list = [];
      docs.forEach(d => {
        list.push(
          createData(
            d.id,
            d.invoice_number,
            d.order_number,
            d.client_name,
            d.amount,
            d.date_payment,
            d.date_conciliation,
          ),
        );
      });
      setRows(list);
    }
  }, [docs]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setItens(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <Paper className={classes.root}>
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>Nota Fiscal</StyledTableCell>
              <StyledTableCell>Pedido</StyledTableCell>
              <StyledTableCell>Cliente</StyledTableCell>
              <StyledTableCell>Valor conciliado</StyledTableCell>
              <StyledTableCell>Data conciliação</StyledTableCell>
              <StyledTableCell>
                <div
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  Data pagamento
                  <GetApp onClick={getXls} style={{ cursor: 'pointer' }} />
                </div>
              </StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map(row => (
              <StyledTableRow key={row.id}>
                <StyledTableCell>{row.invoice_number}</StyledTableCell>
                <StyledTableCell>{row.order_number}</StyledTableCell>
                <StyledTableCell>{row.client_name}</StyledTableCell>
                <StyledTableCell> {formatCurrency(row.amount)}</StyledTableCell>
                <StyledTableCell>
                  {moment(row.date_conciliation).format('DD/MM/YYYY')}
                </StyledTableCell>
                <StyledTableCell>
                  {moment(row.date_payment).format('DD/MM/YYYY')}
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 50, 100]}
        component="div"
        count={total || 0}
        rowsPerPage={itens}
        page={page}
        labelRowsPerPage="Linhas por página:"
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </Paper>
  );
}
